/**
 * A slip read on the profile page has to survive the trip to Match without a
 * server round trip. Keep it in sessionStorage rather than router state: a
 * reload of Match would otherwise re-apply the OCR draft over saved results.
 */
const KEY = 'entrance.slipDraft';

export function saveSlipDraft(draft) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(draft));
  } catch {
    /* private mode or a full storage quota: Match can still be filled by hand */
  }
}

export function readSlipDraft() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearSlipDraft() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* nothing else to do */
  }
}
